"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessUnit = void 0;
var BusinessUnit;
(function (BusinessUnit) {
    /**
     * Campus Studies
     */
    BusinessUnit["CS"] = "CS";
    /**
     * Duales Studium
     */
    BusinessUnit["DS"] = "DS";
    /**
     * Fernstudium
     */
    BusinessUnit["FS"] = "FS";
    /**
     * London Institute for Banking & Finance
     */
    BusinessUnit["LIBF"] = "LIBF";
    /**
     * University of Fredericton
     */
    BusinessUnit["UFRED"] = "UFRED";
    /**
     * Upskilling
     */
    BusinessUnit["UPS"] = "UPS";
})(BusinessUnit || (exports.BusinessUnit = BusinessUnit = {}));
